import {FormaPagoDTO} from './FormaPagoDTO';
import {TipoCFEDTO} from './TipoCFEDTO';
import {ClausulaVentaDTO} from './ClausulaVentaDTO';
import {ModalidadVentaDTO} from './ModalidadVentaDTO';
import {ViaTransportacionDTO} from './ViaTransportacionDTO';

export class IdentificacionCFEDTO
{
  tipoCFE: TipoCFEDTO;
  serie: string;
  numero: number;
  fechaEmision: Date;
  formaPago: FormaPagoDTO;
  clausulaVenta: ClausulaVentaDTO;
  modalidadVenta: ModalidadVentaDTO;
  viaTransportacion: ViaTransportacionDTO;

  public limpiar(): void
  {
    this.tipoCFE = null;
    this.serie = null;
    this.numero = null;
    this.fechaEmision = null;
    this.formaPago = null;
    this.clausulaVenta = null;
    this.modalidadVenta = null;
    this.viaTransportacion = null;
  }

  public toString(): string
  {
    const identificacionCFEDTOStr: string = '(Tipo CFE: ' + this.tipoCFE.descripcion + ', Serie: ' + this.serie + ', ' +
                                             'Número: ' + this.numero + ', Fecha emisión: ' + this.fechaEmision + ', ' +
                                             'Forma pago: ' + this.formaPago.descripcion + ')';

    return identificacionCFEDTOStr;
  }
}
